import React, { Component } from "react";
import WbHttpClient from "./../../../services/wbhttpclient";
import ImgIconComp from "./../../imgcomp";
import { reactLoader, removeReactLoader } from "./../../../utils/common";
import { withTranslation } from 'react-i18next';
class ADOPopup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      domain: "",
      email: "",
      token: "",
      oauth_url: "",
      errorMsg: "",
      loading: true,
      form: 1
    };

    this.wbHttpClient = new WbHttpClient();

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleOAuthFlow = this.handleOAuthFlow.bind(this);
  }

  componentDidMount() {
    reactLoader();
    this.wbHttpClient.get("integration/getAzureOAuthUrl").then(response => {
      this.setState({ loading: false });
      removeReactLoader();
      if (response.data && response.data.status) {
        if (response.data.status === "success") {
          this.setState({ oauth_url: response.data.redirect_url });
        } else {
          // console.log(result.data.error);
          this.setState({
            errorMsg:
              "An error occurred while trying to fetch the OAuth data, please try again"
          });
        }
      } else {
        // console.log(result.data.error);
        this.setState({
          errorMsg:
            "A network error occurred while trying to fetch Azure data, please try again"
        });
      }
    });
  }

  handleInputChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  handleSubmit(event) {
    const { t } = this.props
    event.preventDefault();
    reactLoader();
    this.wbHttpClient
      .post("integration/helloAzure", {
        org: this.state.domain,
        email: this.state.email,
        token: this.state.token
      })
      .then(result => {
        removeReactLoader();
        if (result.data.status === "success") {
          this.props.updateParentState(this.state.domain, "personal_token");
          this.props.closePopup(false);
        } else {
          // console.log(result.data.error);
          this.setState({
            errorMsg:
              t("Azure could not recognize this account, please double check your login info above and try again")
          });
        }
      });
  }

  handleOAuthFlow() {
    const params = `status=no,location=no,toolbar=no,menubar=no,width=400,height=400,\
      top=${window.top.outerHeight / 2 + window.top.screenY - 200},\
      left=${window.top.outerWidth / 2 + window.top.screenX - 200}`;
    const popup = window.open(this.state.oauth_url, "_blank", params);
    
    const timer = setInterval(() => {
      if (popup.location.href && popup.location.href.indexOf("/user/profile/edit?do=mgInt") > 0) {
        this.props.updateParentState(this.state.domain, "bearer");
        popup.close();
        clearInterval(timer);
      } else if (popup.location.href && popup.location.href.indexOf("/goal/index") > 0) {
        this.props.updateParentState(this.state.domain, false);
        popup.close();
        clearInterval(timer);
      }
    }, 500);
    this.props.closePopup(false);
  }

  validateForm(domain, email, token) {
    const emailRegex = /\S+@\S+\.\S+/gi;
    return domain.length > 0 && emailRegex.test(email) && token.length > 0;
  }

  render() {
    if (this.state.loading) return null;
    const formReady = this.validateForm(
      this.state.domain,
      this.state.email,
      this.state.token
    );
    const { t } = this.props
    return (
      <div className="jira-modal-bg">
        <div className="jira-modal ado-modal">
          <div className="ado-popup-header">
            <img
              src={`${wbConfig.baseUrl}/images/logo/azure_devops_logo.png`}
              alt=""
              width="24"
            />
            <div className="ado-popup-title">{t('Connect Azure Devops')}</div>
            <div
              className="clickable"
              onClick={() => this.props.closePopup(true)}
            >
              <ImgIconComp id="close" width="16" height="16" />
            </div>
          </div>
          <div className="ado-popup-body">
            <p>
              {t('Allow WorkBoard to access your Azure DevOps (ADO) account by providing your ADO Personal access token.')}
            </p>

            <div id="ADOform1" style={{ display: this.state.form === 1 ? "block" : "none" }}>
              <a
                onClick={this.handleOAuthFlow}
                className="connect-button"
                style={{ display: this.state.oauth_url ? "" : "none" }}
              >
                {t('Connect')}
              </a>
              <a
                href="javascript:void(0)"
                onClick={() => this.setState({ form: 2 })}
                id="ADOform1action"
                style={{ color: "#52bad5", marginLeft: "10px" }}
              >
                {t('or login with Personal access token')}
              </a>
            </div>

            <div id="ADOform2" style={{ display: this.state.form === 1 ? "none" : "block" }}>
              <form onSubmit={this.handleSubmit}>
                <div>
                  <div className="ado-popup-label">
                    {t('Azure DevOps Organization')}*
                  </div>
                  <div className="ado-popup-row">
                    <div className="ado-popup-prefix">
                      https://dev.azure.com/
                    </div>
                    <input
                      type="text"
                      name="domain"
                      value={this.state.domain}
                      autoComplete="off"
                      placeholder="Ex: yourdomain"
                      className="input-small"
                      onChange={this.handleInputChange}
                    />
                  </div>
                  <div className="ado-popup-label">{t('Azure DevOps email')}*</div>
                  <div className="ado-popup-row">
                    <input
                      type="text"
                      name="email"
                      value={this.state.email}
                      autoComplete="off"
                      placeholder="Ex: name@yourdomain.com"
                      onChange={this.handleInputChange}
                    />
                  </div>
                  <div className="ado-popup-label">{t('Personal access token')}*
                    <div className="ado-popup-tooltip-icon">
                      <div className="ado-popup-tooltip">
                        {t('Personal access tokens (PATs) are alternate passwords you can use to authenticate.')}&nbsp;
                        <a href="https://docs.microsoft.com/en-us/azure/devops/organizations/accounts/use-personal-access-tokens-to-authenticate"
                          target="_blank">{t('Learn more')}</a>
                        <br />
                        {t('The PAT scope must include Read access for')} <b>{t('Work Items')}</b>
                        &nbsp;{t('and Read access for')} <b>{t('Project and Team')}</b>.
                      </div>
                    </div>
                  </div>
                  <div className="ado-popup-row">
                    <input
                      type="text"
                      name="token"
                      value={this.state.token}
                      autoComplete="off"
                      placeholder="Ex: 567"
                      onChange={this.handleInputChange}
                    />
                  </div>
                  <div
                    className="errorMsg"
                    style={{ display: this.state.errorMsg ? "" : "none" }}
                  >
                    {this.state.errorMsg}
                  </div>
                  <input
                    type="submit"
                    className="connect-button"
                    value={t("Connect")}
                    style={{ marginTop: "10px" }}
                    disabled={!formReady}
                  />
                  <a
                    href="javascript:void(0)"
                    onClick={() => this.setState({ form: 1 })}
                    id="ADOform2action"
                    style={{ color: "#52bad5", marginLeft: "10px" }}
                  >
                    {t('or login with OAuth')}
                  </a>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withTranslation()(ADOPopup);
